import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AuthAccessProvider } from "app/core/core.auth";
import { BaseComponent, User, UserContext, UserData } from "app/core/core.component";
import { BusyProvider } from "app/service/busy.service";
import { GestioneUfficioService } from "app/service/gestione-ufficio.service";
import { MessageProvider } from "app/service/message.service";
import { UserService } from "app/service/user.service";
import { UsersComponent } from "app/users/users.component";
import { Message } from "primeng/components/common/api";
import { Subscription } from "rxjs";

declare var $: any;

@Component({
  selector: "app-gestione-ufficio",
  templateUrl: "./gestione-ufficio.component.html",
  styleUrls: ["./gestione-ufficio.component.css"]
})

export class GestioneUfficioComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  static DIALOG_ID = "GestioneUfficioDialog";
  @Output() messaggio  = new EventEmitter<User>();

  userContext: UserContext;
  user: User;
  userData = new UserData();
  errorMessage: string;
  validationMessage: string;
  loading = false;
  uc: UsersComponent;

  uffici: { label: string }[] = [];
  showLogin: boolean = false;
  loginUsername: string = null;
  password: string = null;
  sostituzioneSingolaUfficio: boolean = true;
  selectedUfficio: string = null;
  selectedUffici: string[] = [];

  ufficioAssegnato = "Nessuno";

  msgs: Message[] = [];

  private subscriptions: Subscription[] = [];

  constructor(
    protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private gestioneUfficioService: GestioneUfficioService,
    private busyProvider: BusyProvider
  ) {
    super(authAccess, router, messageProvider);
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (!this.userContext) {
      this.authAccess.invalidate();
      return;
    }
    const statusSub = this.gestioneUfficioService
      .gestioneUfficioComponentStatus$
      .subscribe((u: User) => {
        if (!u) return;
        this.user = u;
        $("#" + GestioneUfficioComponent.DIALOG_ID)
          .modal({ backdrop: "static", keyboard: false });
        this.uffici = this.user.uffici.sort((a, b) => a.localeCompare(b))
          .map(g => ({ label: g, value: g }));
        if (this.user.ufficio && this.user.ufficio.length > 0) {
          this.selectedUfficio = this.user.ufficio[0]
          this.ufficioAssegnato = this.user.ufficio.toString();
          this.sostituzioneSingolaUfficio = this.user.ufficio.length <= 1;
        } else {
          this.uffici.splice(0, 0, { label: "" });
        }
        this.selectedUffici = this.user.ufficio;

        this.subscriptions.push();
      });

    this.subscriptions.push();
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  close() {
    $("#" + GestioneUfficioComponent.DIALOG_ID).modal("hide");
    this.resetState();
  }

  save() {
    this.showLogin = true;
  }

  modificaUfficio() {
    $("#" + GestioneUfficioComponent.DIALOG_ID).modal("hide");
    this.busyProvider.showBusyIndicator();

    let ufficiSelected: string[] = [];
    if (this.sostituzioneSingolaUfficio) {
      ufficiSelected = [this.selectedUfficio]
    } else {
      ufficiSelected = this.selectedUffici;
    }

    this.gestioneUfficioService.changeOffice(this.userContext.srmToken, this.user, ufficiSelected, this.loginUsername, this.password).subscribe(
      (result) => {
        this.busyProvider.hideBusyIndicator();
        this.messaggio.emit(this.user);
        this.resetState();
      },
      (error) => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
        this.resetState();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    );
  }

  closeLogin() {
    this.showLogin = false;
    this.close();
    this.resetState;
  }

  private resetState() {
    this.user = null;
    this.userData = new UserData();
    this.errorMessage = null;
    this.validationMessage = null;
    this.loading = false;
    this.uffici = [];
    this.showLogin = false;
    this.loginUsername = null;
    this.password = null;
    this.sostituzioneSingolaUfficio = true;
    this.selectedUfficio = null;
    this.selectedUffici = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/gestione-ufficio/gestione-ufficio.component.ts